import * as React from 'react';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Card } from 'material-ui';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

const ExternalLookupDetail: React.SFC<any> = ({ model, mpz, producer, registrationNumber, type, vinNumber }) => (
  <Card style={{ padding: '15px', margin: '15px 0' }}>
    <Row>
      {[
        { label: 'Registrační značka', value: registrationNumber },
        { label: 'MPZ', value: mpz },
        { label: 'VIN', value: vinNumber },
        { label: 'Výrobce', value: producer },
        { label: 'Model', value: model },
        { label: 'Druh', value: type }
      ].map(({ label, value }, key) => (
        <Col md={6} key={key}>
          <Row style={{ margin: '15px 0' }}>
            <Col md={6}>
              <div style={{ fontWeight: 'bold' }}>{label}:</div>
            </Col>
            <Col md={6}>
              <div style={{ textAlign: 'right' }}>{value}</div>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  </Card>
);

export const ExternalLookupsForm = ({ vehicle, closeItem }) => (
  <div>
    <Grid fluid={true}>{vehicle ? <ExternalLookupDetail {...vehicle} /> : <h4>Žádné vozidlo nebylo nalezeno</h4>}</Grid>
    <Button label={'Zavřít'} onClick={closeItem} style={{ margin: '15px' }} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/vehicle/ExternalLookupsForm.tsx